import { createRouter, createWebHistory } from '@ionic/vue-router';
import My from '@/view/my'
import lawyer from '@/view/lawyer'
import news from '@/view/news'
import cased from '@/view/case'
import User from '@/view/user'
import Card from '@/view/card'
import UploadFile from '@/view/uploadFile'
import Certification from '@/view/certification'

// const defaultPage = '/nativeTab/news'
const defaultPage = '/nativeTab/my'

const routes = [
  {
    path: '/',
    redirect: defaultPage
  },
  ...news.routes,
  ...lawyer.routes,
  ...cased.routes,
  ...My.routes,
  ...User.routes,
  ...Card.routes,
  ...UploadFile.routes,
  ...Certification.routes,
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// router.beforeEach(async (to, from, next) => {
//   console.log('--to, from', to, from)
//   const routePath = routes.map(route => route.path)
//   if (to.path == '/login') {
//     next()
//     console.log('path-1')
//   } else if (!localStorage.token) {
//     next({ path: '/login' })
//     console.log('path-2')
//   } else if (to.path == '/') {
//     next({ path: defaultPage })
//     console.log('path-3')
//   } else {
//     next()
//     console.log('path-4')
//   }
// })


export default router
